import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import '@/styles/globals.css'
import { App } from '@/app'

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  registerSW({
    immediate: true,
    onRegisteredSW(swUrl: string | undefined) {
      // eslint-disable-next-line no-console
      console.info('PWA service worker registered:', swUrl)
    },
    onOfflineReady() {
      // eslint-disable-next-line no-console
      console.info('PWA ready to work offline')
    },
    onNeedRefresh() {
      // eslint-disable-next-line no-console
      console.info('New content available, refresh to update.')
    },
  })
}

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
)
